import { Level1MenuItem } from "@/features";
import { MdElectricBolt } from "react-icons/md";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { permissionsEnergy } from "@/utils";
import { RootState, useAppSelector } from "@/app/store";

const parentPath = "energy";

export const EnergyMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const hasCompanies = useAppSelector(
    (state: RootState) => state?.auth?.user?.hasCompanies,
  );

  return (
    <Level1MenuItem
      link={`/${parentPath}`}
      label={gettext("Energy")}
      icon={<MdElectricBolt size={18} className="mx-3" />}
      codes={permissionsEnergy}
      feature="consumption"
      hide={!hasCompanies}
    />
  );
};
